import { render } from "./AppointmentStatus.vue?vue&type=template&id=1bada816&scoped=true"
import script from "./AppointmentStatus.vue?vue&type=script&lang=js"
export * from "./AppointmentStatus.vue?vue&type=script&lang=js"

import "./AppointmentStatus.vue?vue&type=style&index=0&id=1bada816&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bada816"]])

export default __exports__